// Which selected course-registration rows the bulk "Unpublish Selected" action
// may actually act on.
//
// Only a senate-approved registration has a published result snapshot behind it,
// and unpublishing needs both the student and the calendar. Rows missing either
// would send `student_id: "undefined"` to the mutation, so they are filtered out
// here rather than failing one-by-one at the network layer.

/** Mirrors App\Enums\SenateApprovalStatus::Approved on the backend. */
export const SENATE_APPROVED = 'Approved';

export interface UnpublishableRow {
  id: string | number;
  student_id?: string | number | null;
  academic_calendar_id?: string | number | null;
  senate_approval_status?: string | null;
}

export interface UnpublishTarget {
  student_id: string;
  academic_calendar_id: string;
}

export function isUnpublishable(row: UnpublishableRow | null | undefined): boolean {
  if (!row) return false;
  if (row.senate_approval_status !== SENATE_APPROVED) return false;

  return row.student_id !== null && row.student_id !== undefined && row.student_id !== ''
    && row.academic_calendar_id !== null && row.academic_calendar_id !== undefined && row.academic_calendar_id !== '';
}

/**
 * Reduce a selection to the deduplicated set of (student, calendar) pairs to
 * unpublish. A student with several registrations in the same semester appears
 * once, because unPublishStudentResult works per student per calendar.
 */
export function buildUnpublishTargets(
  rows: Array<UnpublishableRow | null | undefined>,
): UnpublishTarget[] {
  const seen = new Set<string>();
  const targets: UnpublishTarget[] = [];

  for (const row of rows) {
    if (!isUnpublishable(row)) continue;

    const target = {
      student_id: String(row!.student_id),
      academic_calendar_id: String(row!.academic_calendar_id),
    };
    const key = `${target.student_id}_${target.academic_calendar_id}`;

    if (seen.has(key)) continue;
    seen.add(key);
    targets.push(target);
  }

  return targets;
}
